const anomalyParamsUp: AnomalyParams = { 'color': "#6DA544", 'text': 'a augmenté', 'icon': 'https://uploads-ssl.webflow.com/641b227fcd5cd9726f0781aa/667ad40fad7f4d6c641467cb_trend-up.svg' }
const anomalyParamsDown: AnomalyParams = { 'color': "#F55536", 'text': 'a baissé', 'icon': 'https://uploads-ssl.webflow.com/641b227fcd5cd9726f0781aa/667ad409cc8ba948bf6788d7_trend-down.svg' }
const anomalyParamsDefault: AnomalyParams = { 'color': "#161032", 'text': '', 'icon': '' }

export const AnomalyParamsOptions = {
  up: anomalyParamsUp,
  down: anomalyParamsDown,
  default: anomalyParamsDefault
}

export interface AnomalyParams {
  color: string,
  text: string,
  icon: string
}

export interface Anomaly {
  value: number;
  series_name: string;
  params: AnomalyParams
}

export interface Anomalies {
  time: number;
  anomalies: Anomaly[];
}